<template>
    <div class="declare-helper-step-bar">
        <el-steps :active="this.step" align-center finish-status="success" simple>
            <el-step>
                <template slot="title">
                    <div class="step-title" @click="onClickStep(1)">1. 設定申報期別</div>
                </template>
            </el-step>
            <el-step>
                <template slot="title">
                    <div class="step-title" @click="onClickStep(2)">2. 申報銷項</div>
                </template>
            </el-step>
            <el-step>
                <template slot="title">
                    <div class="step-title" @click="onClickStep(3)">3. 申報進項</div>
                </template>
            </el-step>
            <el-step>
                <template slot="title">
                    <div class="step-title" @click="onClickStep(4)">4. 申報清單＆匯出</div>
                </template>
            </el-step>
        </el-steps>
    </div>
</template>

<script>
export default {
    props: ['step'],
    methods: {
        onClickStep(n) {
            this.$emit('onClickStep', n);
        },
    },
};
</script>

<style lang="scss">
.declare-helper-step-bar {
    width: 750px;

    .el-steps--simple {
        padding: 8px 15px 8px 30px;
        background-color: #463cb2;
        color: #fff;

        .el-step.is-simple:not(:last-of-type) .el-step__title {
            max-width: unset;
        }

        .el-step__head {
            top: 4px;
            height: 24px;

            &.is-process {
                color: #fff;
                border-color: #fff;
                color: #7ae843 !important;
                border-color: #7ae843;
                cursor: default;
            }
            &.is-success {
                color: #7ae843 !important;
                border-color: #7ae843;
            }
            &.is-wait {
                .el-step__icon {
                    opacity: 0.3;
                }
            }
        }

        .el-step__title {
            cursor: pointer;

            &.is-process {
                color: #7ae843;
                cursor: default;

                &:hover {
                    color: #7ae843;
                }
            }
            &.is-success {
                color: #7ae843;

                &:hover {
                    color: #97ff63;
                }
            }

            &:hover {
                color: #fff;
            }
        }

        .step-title {
            font-size: 10.5pt;
            font-weight: bold;
        }
        .el-step__arrow {
            transform: scale(0.9);
        }
        .el-step__arrow::before,
        .el-step__arrow::after {
            background-color: #aaa;
        }
    }

    .step-title {
        // position: relative;
        // display: inline-block;
        // padding: 0 20px;
        // font-size: 11pt;
        // cursor: pointer;

        // &:hover {
        //     color: #463cb2;
        // }
    }
}
</style>
